import { render, staticRenderFns } from "./ZxFawuBeizhixingrenForm.vue?vue&type=template&id=72c8badf&scoped=true&"
import script from "./ZxFawuBeizhixingrenForm.vue?vue&type=script&lang=js&"
export * from "./ZxFawuBeizhixingrenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8badf",
  null
  
)

export default component.exports